import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CmsConfig, CustomLoginGuard, FeaturesConfigModule, GlobalMessageService, I18nModule, NotAuthGuard, provideConfig, UrlModule, WindowRef } from '@spartacus/core';
import { FormErrorsModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, IconModule, PasswordVisibilityToggleModule, SpinnerModule } from '@spartacus/storefront';
import { LoginFormComponentService } from '@spartacus/user/account/components';
import { CustomIconsModule } from '../../../../../../custom/icons/custom-icons.module';
import { CustomAuthService } from '../../../../../../services/auth/custom-auth.service';
import { CustomLoginFormComponentService } from '../custom-login/service/login-form-component.service';
import { CustomLoginFormComponent } from './custom-login-form.component';

@NgModule({
  exports: [CustomLoginFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    IconModule,
    FormErrorsModule,
    SpinnerModule,
    PasswordVisibilityToggleModule,
    FeaturesConfigModule,
    FormRequiredAsterisksComponent,
    FormRequiredLegendComponent,
    CustomLoginFormComponent,
    CustomIconsModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ReturningCustomerLoginComponent: {
          component: CustomLoginFormComponent,
          guards: [NotAuthGuard, CustomLoginGuard],
          providers: [
            {
              provide: LoginFormComponentService,
              useClass: CustomLoginFormComponentService,
              deps: [CustomAuthService, GlobalMessageService, WindowRef]
            }
          ]
        }
      }
    })
  ]
})
export class CustomLoginFormModule {}
